import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

@Component({
  selector: 'app-menu-style5',
  templateUrl: './menu-style5.component.html',
  styleUrls: ['./menu-style5.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MenuStyle5Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/mega-menu/menu-style5/menu-style5.component.ts